"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captcha = captcha;
exports.deleteWorkbenchBlock = deleteWorkbenchBlock;
exports.getBlockCodeByApplyType = getBlockCodeByApplyType;
exports.getBtnPermissions = getBtnPermissions;
exports.getInfo = getInfo;
exports.getSysUserWorkbenchBlockByBlockCode = getSysUserWorkbenchBlockByBlockCode;
exports.getTermByTermNo = getTermByTermNo;
exports.getWorkbenchBlock = getWorkbenchBlock;
exports.login = login;
exports.logout = logout;
exports.resendActivationEmail = resendActivationEmail;
exports.resetPassword = resetPassword;
exports.restoreWorkbenchBlock = restoreWorkbenchBlock;
exports.saveWorkbenchBlock = saveWorkbenchBlock;
exports.showSuggestionBoard = showSuggestionBoard;
exports.updateFixFlagWorkbenchBlock = updateFixFlagWorkbenchBlock;
exports.updateOldSystemPassword = updateOldSystemPassword;
exports.updateSysUserWorkbenchBlock = updateSysUserWorkbenchBlock;
exports.updateTermNo = updateTermNo;
exports.updateWorkbenchBlock = updateWorkbenchBlock;
var _request = _interopRequireDefault(require("@/utils/request"));
/* 登录 */
function login(data) {
  return (0, _request.default)({
    url: '/sitceb-authentication/login',
    method: 'post',
    data: data
  });
}

/* 获取验证码 */
function captcha() {
  return (0, _request.default)({
    url: '/sitceb-authentication/captcha',
    method: 'get',
    responseType: 'blob'
  });
}

/* 获取用户信息 */
function getInfo(params) {
  return (0, _request.default)({
    url: '/sitceb-authentication/system/security/getSessionAttrsAndNoPermits',
    method: 'get',
    params: params,
    timeout: 20 * 1000
  });
}

// 重新发送激活邮件
function resendActivationEmail(accountNo, activateEmail) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/resendActivationEmail/' + accountNo + '/' + activateEmail,
    method: 'get'
  });
}

/* 登出 */
function logout() {
  return (0, _request.default)({
    url: '/sitceb-authentication/logout',
    method: 'get'
  });
}

/* 获取当前路由相关权限 */
function getBtnPermissions(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysMenu/getBtnPermissions',
    method: 'get',
    params: query
  });
}

/* 重设密码 */
function resetPassword(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysUser/modifyPwd',
    method: 'post',
    data: data
  });
}

/* 工作台配置模块 */

/* 1.加载功能区块 */
function getWorkbenchBlock(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/selectWorkbenchBlock/' + query.deploy,
    method: 'get'
  });
}

/* 2.隐藏功能区块 */
function deleteWorkbenchBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/deleteWorkbenchBlock',
    method: 'post',
    data: data
  });
}

/* 3.编辑功能区块 */
function updateWorkbenchBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/updateWorkbenchBlock',
    method: 'post',
    data: data
  });
}

/* 4.添加功能区块 */
function saveWorkbenchBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/saveWorkbenchBlock',
    method: 'post',
    data: data
  });
}

/* 5.恢复默认 */
function restoreWorkbenchBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/restoreSysUserWorkbenchBlock',
    method: 'post',
    data: data
  });
}

/* 6.固定 暂不用*/
function updateFixFlagWorkbenchBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/updateFixFlagWorkbenchBlock',
    method: 'post',
    data: data
  });
}

/* 7。根据区块找到对应的子类型数据字典进行获取 */
function getSysUserWorkbenchBlockByBlockCode(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/getSysUserWorkbenchBlockByBlockCode',
    method: 'get',
    params: query
  });
}

/* 8. 根据船/岸端标识，获取功能区块数据字典清单 */
function getBlockCodeByApplyType(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/getBlockCodeByApplyType',
    method: 'get',
    params: query
  });
}

/* 9. 移动 */
function updateSysUserWorkbenchBlock(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysWorkbenchBlock/updateSysUserWorkbenchBlock',
    method: 'post',
    data: data
  });
}

// 修改旧系统密码
function updateOldSystemPassword(accountNo, password) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/updateOldSystemPassword/' + accountNo + '?password=' + password,
    method: 'get'
  });
}
// 获取条款信息
function getTermByTermNo(termNos) {
  return (0, _request.default)({
    url: '/sitceb-system-service/webOnlineTerms/getByTermNo',
    method: 'post',
    data: termNos
  });
}
// 更新当前用户的条款信息
function updateTermNo(termNos) {
  return (0, _request.default)({
    url: '/sitceb-system-service/webOnlineTerms/updateTermNo',
    method: 'post',
    data: termNos
  });
}
// 首页调查问卷弹框是否显示
function showSuggestionBoard() {
  return (0, _request.default)({
    url: '/sitceb-system-service/common/showSuggestionBoard',
    method: 'get'
  });
}